export default "__VITE_ASSET__D_So1M3$__"